import {Condition, type Journey} from "../engine/Condition";
import {normalizePath, onCurrentAndFuturePageAccess} from "../../../utils/PageAccessHelpers.js";
import {testPath} from "./PathCondition";
import {updatePageVisit} from "../../../utils/PageAccessHelpers.js";
import {merchantVariableModule} from "../../merchant-state/MerchantVariableModule.js";

const PAGE_VISIT_ACTIVATION_TYPE = {
    atLeast: "atLeast", // default.
    exact: "exact",
    atMost: "atMost",
};

// TODO @branch we also want some rules to just always trigger, this is incredibly stupid
function shouldActivate(numVisits: number, expectedNumVisits: number, activationType: string) {
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.exact) {
        return numVisits === expectedNumVisits;
    }
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.atMost) {
        return numVisits <= expectedNumVisits;
    }
    return numVisits >= expectedNumVisits;
}

function shouldSaveResult(result: boolean | null, activationType: string) {
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.exact) {
        return true;
    }
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.atMost) {
        return result === true;
    }
    return result === false;
}

export interface NthPageVisitOptions {
    numPages?: number;
    scope?: string;
    altScope?: string;
    timeWindow?: number;
    pathInclude?: string | string[];
    pathExclude?: string | string[];
    pathOneOf?: string | string[];
    filterFunction?: string | any[];
    activationType?: string;
}

export class NthPageVisitCondition extends Condition<NthPageVisitOptions> {
    constructor(journey: Journey, options: NthPageVisitOptions, requestReEval: () => void) {
        super(journey, options, requestReEval);

        const {
            numPages = 1,
            activationType = PAGE_VISIT_ACTIVATION_TYPE.atLeast,
            scope = this.journey.alias,
            altScope,
            timeWindow,
        } = this.options;

        const pageAccessHandler = onCurrentAndFuturePageAccess((url) => {
            const currentPath = normalizePath(url);
            const pathMatches = this.testPath(currentPath);

            // TODO @branch implement cleaner
            const [currentVisit, pageVisitsMap] = updatePageVisit(url, {
                [scope]: pathMatches,
            });

            const oldestAllowedTimestamp = timeWindow ? Date.now() - timeWindow * 1000 : -Infinity;
            const numCountedVisits = [...pageVisitsMap.values()].filter(
                visit => (visit.lastVisit >= oldestAllowedTimestamp && visit[scope])
            ).length;

            // Store the counter variable, and also save in a possibly alternate counter (used for counter before and after reg, that should overwrite another variable)
            // TODO the variable system is incredibly complex, wow
            merchantVariableModule.set(scope + ".count", numCountedVisits);
            if (altScope) {
                merchantVariableModule.set(altScope + ".count", numCountedVisits);
            }

            const prevResult = this.cachedResult;
            this.cachedResult = pathMatches && shouldActivate(numCountedVisits, numPages, activationType);
            if (shouldSaveResult(this.cachedResult, activationType)) {
                updatePageVisit(url, {
                    ["numVisits." + scope]: numCountedVisits,
                });
            }

            if (prevResult != null) {
                // TODO @branch not nice!
                this.requestReEval();
            }
        });
        this.addCleanupJob(pageAccessHandler);
    }

    testPath(path: string) {
        return testPath(path,
            this.options.pathInclude,
            this.options.pathExclude,
            this.options.pathOneOf,
            this.options.filterFunction);
    }

    evaluate() {
        return this.cachedResult;
    }
}
